import React from "react"

import sombraCelular from "../../../images/sombra-celular.png"
import iphone from "../../../images/iphone.png"
import styled from "styled-components"
import {
  SectionWrapper,
  SectionTitle,
  DetailList,
  DetailListItem,
} from "../landing-section.styles"

export const SectionBlue = styled.section`
  background-color: #00c6c8;
`

export const SectionSignatreWrapper = styled(SectionWrapper)`
  align-items: center;
`

export const SectionImageSignatureBox = styled.div`
  margin: 20px 0 40px;
  position: relative;

  &:after {
    background-image: url(${sombraCelular});
    content: "";
    width: 100%;
    height: 100px;
    position: absolute;
    display: inline-block;
    background-repeat: no-repeat;
    background-position: center;
    left: 0px;
    z-index: 1;
    background-size: 90%;
    bottom: -60px;
  }

  @media screen and (min-width: 1100px) {
    margin: 0;

    &:after {
      bottom: -70px;
    }
  }
`

export const ImageSignature = styled.img`
  height: 240px;
  margin: 0 auto;
  display: inherit;

  @media screen and (min-width: 1100px) {
    height: 486px;
  }
`

export const SectionDivisorSignature = styled.div`
  @media screen and (min-width: 1100px) {
    flex-basis: 680px;
  }
`

export const ShowOnlyDesktop = styled.div`
  display: none;

  @media screen and (min-width: 1100px) {
    display: inherit;
  }
`

export const ShowOnlyMobileAndTablet = styled.div`
  display: inherit;

  @media screen and (min-width: 1100px) {
    display: none;
  }
`

export const DetaliLisItemSignatre = styled(DetailListItem)``

export default function SectionSignature() {
  return (
    <SectionBlue>
      <SectionSignatreWrapper>
        <SectionDivisorSignature>
          <SectionTitle>
            Assinatura <br />
            de <b>Contrato</b>
          </SectionTitle>
          <ShowOnlyDesktop>
            <DetailList>
              <DetailListItem>
                Se você precisar assinar um contrato de cessão, não é necessário
                estar na frente de um computador. Você pode assinar no seu
                celular.
              </DetailListItem>
            </DetailList>
          </ShowOnlyDesktop>
        </SectionDivisorSignature>
        <SectionImageSignatureBox>
          <ImageSignature src={iphone} data-zoomable />
        </SectionImageSignatureBox>
        <ShowOnlyMobileAndTablet>
          <DetailList>
            <DetailListItem>
              Se você precisar assinar um contrato de cessão, não é necessário
              estar na frente de um computador. Você pode assinar no seu
              celular.
            </DetailListItem>
          </DetailList>
        </ShowOnlyMobileAndTablet>
      </SectionSignatreWrapper>
    </SectionBlue>
  )
}
